export default function FormatAddress(address) {
  if (!address) return '';

  const {
    addressLines,
    county,
    country,
    postCode,
  } = address;

  const addressArray = [...addressLines, county, country, postCode];

  return `${addressArray.filter(o => !!o).join(', ')}`;
}

export const joinAddressLines = (address) => {
  const LIMIT = 40; // 40 characters per address line

  if (!address || !address?.addressLines?.length) return [];

  return address.addressLines.reduce(
    (acc, cur) => {
      if (!cur) return acc;
      if (!acc.length) {
        acc.push(cur);
        return acc;
      }
      const lastElement = acc[acc.length - 1];
      const shouldAppend = (lastElement.length + cur.length) <= LIMIT;
      if (shouldAppend) {
        acc[acc.length - 1] = `${lastElement}, ${cur}`;
      } else {
        acc.push(cur);
      }
      return acc;
    },
    [],
  );
};

export const formatCardAddress = (address, isOverseas = false) => {
  if (!address) return '';
  const {
    country,
    county,
    postCode,
    town,
  } = address ?? {};
  if (isOverseas) {
    return `${town ?? ''}${town?.length > 0 && country?.length > 0 ? ',' : ''} ${country ?? ''}`;
  }
  return `${county ?? ''}${county?.length > 0 && postCode?.length > 0 ? ',' : ''} ${postCode ?? ''}`;
};

export const formatSearchAddress = (address, isOverseas = false) => {
  if (!address) return '';
  const {
    country,
    county,
    town,
  } = address ?? {};

  if (isOverseas) {
    return `${town ?? ''}${town?.length > 0 && country?.length > 0 ? ',' : ''} ${country ?? ''}`;
  }
  return `${town ?? ''}${town?.length > 0 && county?.length > 0 ? ',' : ''} ${county ?? ''}`;
};
